/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-10 10:39:45
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

// Define name and type for 3 main actions: Request, Success, Failure
export const TRIGGER_SYNC_REQUEST = 'TRIGGER_SYNC_REQUEST';
type TRIGGER_SYNC_REQUEST_TYPE = 'TRIGGER_SYNC_REQUEST';

export const TRIGGER_SYNC_SUCCESS = 'TRIGGER_SYNC_SUCCESS';
type TRIGGER_SYNC_SUCCESS_TYPE = 'TRIGGER_SYNC_SUCCESS';

export const TRIGGER_SYNC_FAILURE = 'TRIGGER_SYNC_FAILURE';
type TRIGGER_SYNC_FAILURE_TYPE = 'TRIGGER_SYNC_FAILURE';

export const GET_SYNC_STATUS_REQUEST = 'GET_SYNC_STATUS_REQUEST';
type GET_SYNC_STATUS_REQUEST_TYPE = 'GET_SYNC_STATUS_REQUEST';

export const GET_SYNC_STATUS_SUCCESS = 'GET_SYNC_STATUS_SUCCESS';
type GET_SYNC_STATUS_SUCCESS_TYPE = 'GET_SYNC_STATUS_SUCCESS';

export const GET_SYNC_STATUS_FAILURE = 'GET_SYNC_STATUS_FAILURE';
type GET_SYNC_STATUS_FAILURE_TYPE = 'GET_SYNC_STATUS_FAILURE';

export const GET_SYNC_PROCESS_STATUS_REQUEST = 'GET_SYNC_PROCESS_STATUS_REQUEST';
type GET_SYNC_PROCESS_STATUS_REQUEST_TYPE = 'GET_SYNC_PROCESS_STATUS_REQUEST';

export const GET_SYNC_PROCESS_STATUS_SUCCESS = 'GET_SYNC_PROCESS_STATUS_SUCCESS';
type GET_SYNC_PROCESS_STATUS_SUCCESS_TYPE = 'GET_SYNC_PROCESS_STATUS_SUCCESS';

export const GET_SYNC_PROCESS_STATUS_FAILURE = 'GET_SYNC_PROCESS_STATUS_FAILURE';
type GET_SYNC_PROCESS_STATUS_FAILURE_TYPE = 'GET_SYNC_PROCESS_STATUS_FAILURE';

export const GET_AVAILABLE_SYNC_LIST_REQUEST = 'GET_AVAILABLE_SYNC_LIST_REQUEST';
type GET_AVAILABLE_SYNC_LIST_REQUEST_TYPE = 'GET_AVAILABLE_SYNC_LIST_REQUEST';

export const GET_AVAILABLE_SYNC_LIST_SUCCESS = 'GET_AVAILABLE_SYNC_LIST_SUCCESS';
type GET_AVAILABLE_SYNC_LIST_SUCCESS_TYPE = 'GET_AVAILABLE_SYNC_LIST_SUCCESS';

export const GET_AVAILABLE_SYNC_LIST_FAILURE = 'GET_AVAILABLE_SYNC_LIST_FAILURE';
type GET_AVAILABLE_SYNC_LIST_FAILURE_TYPE = 'GET_AVAILABLE_SYNC_LIST_FAILURE';

export const GET_SYNC_SCHEDULE_REQUEST = 'GET_SYNC_SCHEDULE_REQUEST';
type GET_SYNC_SCHEDULE_REQUEST_TYPE = 'GET_SYNC_SCHEDULE_REQUEST';

export const GET_SYNC_SCHEDULE_SUCCESS = 'GET_SYNC_SCHEDULE_SUCCESS';
type GET_SYNC_SCHEDULE_SUCCESS_TYPE = 'GET_SYNC_SCHEDULE_SUCCESS';

export const GET_SYNC_SCHEDULE_FAILURE = 'GET_SYNC_SCHEDULE_FAILURE';
type GET_SYNC_SCHEDULE_FAILURE_TYPE = 'GET_SYNC_SCHEDULE_FAILURE';

export const UPDATE_SYNC_PRIORITY_REQUEST = 'UPDATE_SYNC_PRIORITY_REQUEST';
type UPDATE_SYNC_PRIORITY_REQUEST_TYPE = 'UPDATE_SYNC_PRIORITY_REQUEST';

export const UPDATE_SYNC_PRIORITY_SUCCESS = 'UPDATE_SYNC_PRIORITY_SUCCESS';
type UPDATE_SYNC_PRIORITY_SUCCESS_TYPE = 'UPDATE_SYNC_PRIORITY_SUCCESS';

export const UPDATE_SYNC_PRIORITY_FAILURE = 'UPDATE_SYNC_PRIORITY_FAILURE';
type UPDATE_SYNC_PRIORITY_FAILURE_TYPE = 'UPDATE_SYNC_PRIORITY_FAILURE';

export const SAVE_SYNC_SCHEDULE_REQUEST = 'SAVE_SYNC_SCHEDULE_REQUEST';
type SAVE_SYNC_SCHEDULE_REQUEST_TYPE = 'SAVE_SYNC_SCHEDULE_REQUEST';

export const SAVE_SYNC_SCHEDULE_SUCCESS = 'SAVE_SYNC_SCHEDULE_SUCCESS';
type SAVE_SYNC_SCHEDULE_SUCCESS_TYPE = 'SAVE_SYNC_SCHEDULE_SUCCESS';

export const SAVE_SYNC_SCHEDULE_FAILURE = 'SAVE_SYNC_SCHEDULE_FAILURE';
type SAVE_SYNC_SCHEDULE_FAILURE_TYPE = 'SAVE_SYNC_SCHEDULE_FAILURE';

export const GET_SYNC_HISTORY_REQUEST = 'GET_SYNC_HISTORY_REQUEST';
type GET_SYNC_HISTORY_REQUEST_TYPE = 'GET_SYNC_HISTORY_REQUEST';

export const GET_SYNC_HISTORY_SUCCESS = 'GET_SYNC_HISTORY_SUCCESS';
type GET_SYNC_HISTORY_SUCCESS_TYPE = 'GET_SYNC_HISTORY_SUCCESS';

export const GET_SYNC_HISTORY_FAILURE = 'GET_SYNC_HISTORY_FAILURE';
type GET_SYNC_HISTORY_FAILURE_TYPE = 'GET_SYNC_HISTORY_FAILURE';

export const RESET_SYNC_STATUS = 'RESET_SYNC_STATUS';
type RESET_SYNC_STATUS_TYPE = 'RESET_SYNC_STATUS';

export const ENABLE_AUTO_SYNC_REQUEST = 'ENABLE_AUTO_SYNC_REQUEST';
type ENABLE_AUTO_SYNC_REQUEST_TYPE = 'ENABLE_AUTO_SYNC';

export const ENABLE_AUTO_SYNC_SUCCESS = 'ENABLE_AUTO_SYNC_SUCCESS';
type ENABLE_AUTO_SYNC_SUCCESS_TYPE = 'ENABLE_AUTO_SYNC_SUCCESS';

export const ENABLE_AUTO_SYNC_FAILURE = 'ENABLE_AUTO_SYNC_FAILURE';
type ENABLE_AUTO_SYNC_FAILURE_TYPE = 'ENABLE_AUTO_SYNC_FAILURE';

type SyncResponseType = {
  status: string
};

type GetSyncStatusSuccess = {
  data: {
    lastSynced: Object
  }
};

type GetSyncProcessStatusSuccess = {
  data: {
    flow: Object,
    schedule: Object,
    process: Object
  }
};

type GetAvailableSyncListSuccess = {
  data: {
    available: Array<Object>,
    info: Object
  }
};

type SyncScheduleSuccess = {
  data: {
    schedule: Object
  }
};

type SyncHistorySuccess = {
  data: Object
};

type SyncFailure = { error: any };
// Define type for each action
// Action<Type, Payload>
type TriggerSyncRequestActionType = Action<TRIGGER_SYNC_REQUEST_TYPE, null>;
type TriggerSyncSuccessActionType = Action<TRIGGER_SYNC_SUCCESS_TYPE, SyncResponseType>;
type TriggerSyncFailureActionType = Action<TRIGGER_SYNC_FAILURE_TYPE, SyncFailure>;

type GetSyncStatusRequestAction = Action<GET_SYNC_STATUS_REQUEST_TYPE, null>;

type GetSyncStatusSuccessAction = Action<GET_SYNC_STATUS_SUCCESS_TYPE, GetSyncStatusSuccess>;

type GetSyncStatusFailureAction = Action<GET_SYNC_STATUS_FAILURE_TYPE, SyncFailure>;

type GetSyncProcessStatusRequestAction = Action<GET_SYNC_PROCESS_STATUS_REQUEST_TYPE, null>;

type GetSyncProcessStatusSuccessAction = Action<
  GET_SYNC_PROCESS_STATUS_SUCCESS_TYPE,
  GetSyncProcessStatusSuccess
>;

type GetSyncProcessStatusFailureAction = Action<GET_SYNC_PROCESS_STATUS_FAILURE_TYPE, SyncFailure>;

type GetAvailableSyncListRequestAction = Action<GET_AVAILABLE_SYNC_LIST_REQUEST_TYPE, null>;

type GetAvailableSyncListSuccessAction = Action<
  GET_AVAILABLE_SYNC_LIST_SUCCESS_TYPE,
  GetAvailableSyncListSuccess
>;

type GetAvailableSyncListFailureAction = Action<GET_AVAILABLE_SYNC_LIST_FAILURE_TYPE, SyncFailure>;

type GetSyncScheduleRequestAction = Action<GET_SYNC_SCHEDULE_REQUEST_TYPE, null>;

type GetSyncScheduleSuccessAction = Action<GET_SYNC_SCHEDULE_SUCCESS_TYPE, SyncScheduleSuccess>;

type GetSyncScheduleFailureAction = Action<GET_SYNC_SCHEDULE_FAILURE_TYPE, SyncFailure>;

type UpdateSyncPriorityRequestAction = Action<UPDATE_SYNC_PRIORITY_REQUEST_TYPE, null>;

type UpdateSyncPrioritySuccessAction = Action<
  UPDATE_SYNC_PRIORITY_SUCCESS_TYPE,
  SyncScheduleSuccess
>;

type UpdateSyncPriorityFailureAction = Action<UPDATE_SYNC_PRIORITY_FAILURE_TYPE, SyncFailure>;

type SaveSyncScheduleRequestAction = Action<SAVE_SYNC_SCHEDULE_REQUEST_TYPE, null>;

type SaveSyncScheduleSuccessAction = Action<SAVE_SYNC_SCHEDULE_SUCCESS_TYPE, SyncScheduleSuccess>;

type SaveSyncScheduleFailureAction = Action<SAVE_SYNC_SCHEDULE_FAILURE_TYPE, SyncFailure>;

type GetSyncHistoryRequestAction = Action<GET_SYNC_HISTORY_REQUEST_TYPE, null>;

type GetSyncHistorySuccessAction = Action<GET_SYNC_HISTORY_SUCCESS_TYPE, SyncHistorySuccess>;

type GetSyncHistoryFailureAction = Action<GET_SYNC_HISTORY_FAILURE_TYPE, SyncFailure>;

type EnableAutoSyncRequestAction = Action<ENABLE_AUTO_SYNC_REQUEST_TYPE, null>;

type EnableAutoSyncSuccessAction = Action<ENABLE_AUTO_SYNC_SUCCESS_TYPE, SyncHistorySuccess>;

type EnableAutoSyncFailureAction = Action<ENABLE_AUTO_SYNC_FAILURE_TYPE, SyncFailure>;

type ResetSyncStatus = Action<RESET_SYNC_STATUS_TYPE, null>;

export type SyncActionType =
  | TriggerSyncRequestActionType
  | TriggerSyncSuccessActionType
  | TriggerSyncFailureActionType
  | GetSyncStatusRequestAction
  | GetSyncStatusSuccessAction
  | GetSyncStatusFailureAction
  | GetSyncProcessStatusRequestAction
  | GetSyncProcessStatusSuccessAction
  | GetSyncProcessStatusFailureAction
  | ResetSyncStatus
  | GetAvailableSyncListRequestAction
  | GetAvailableSyncListSuccessAction
  | GetAvailableSyncListFailureAction
  | GetSyncScheduleRequestAction
  | GetSyncScheduleSuccessAction
  | GetSyncScheduleFailureAction
  | UpdateSyncPriorityRequestAction
  | UpdateSyncPrioritySuccessAction
  | UpdateSyncPriorityFailureAction
  | SaveSyncScheduleRequestAction
  | SaveSyncScheduleSuccessAction
  | SaveSyncScheduleFailureAction
  | GetSyncHistoryRequestAction
  | GetSyncHistorySuccessAction
  | EnableAutoSyncRequestAction
  | EnableAutoSyncSuccessAction
  | EnableAutoSyncFailureAction
  | GetSyncHistoryFailureAction;

export type SyncStateType = {
  triggerSyncLoading: boolean,
  triggerSyncSuccess: boolean,
  error: any,
  response: Object,
  syncLoading: boolean,
  syncProcessLoading: boolean,
  lastSyncedDoneAt: number,
  flow: Object,
  scheduleSyncInfo: Object,
  syncProcess: Object,
  getAvailableSyncListLoading: boolean,
  getAvailableSyncListSuccess: boolean,
  availableSyncList: Array<string>,
  collectionBoostAllExists: boolean,
  getSyncScheduleLoading: boolean,
  saveSyncScheduleLoading: boolean,
  syncSchedule: Object,
  getSyncHistoryLoading: boolean,
  syncHistory: Object,
  syncHistoryTotal: number
};
